<template>
  <div class="roller-loader" :style="{ '--size': `${size}px` }"></div>
</template>

<script>
export default {
  name: 'loader4',

  props: {
    size: {
      type: Number,
      required: false,
      default: 22,
    },
  },

  data() {
    return {
      color: '#10328f',
      loading: true,
    }
  },
}
</script>

<style lang="scss" scoped>
.roller-loader {
  display: inline-block;
  width: var(--size);
  height: var(--size);

  display: flex;
  align-items: center;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  &:after {
    content: ' ';
    display: block;
    width: var(--size);
    height: var(--size);

    border-radius: 50%;
    border: calc(var(--size) * 0.15) solid #10328f;

    border-color: #10328f transparent #10328f transparent;

    animation: 1.2s linear spin infinite;
  }
}
</style>
